import React from "react";
import ArrowTableDownSvg from "../../../components/svgComponents/ArrowTableDownSvg";

const TableHead = ({ thName, sortData, classes = "" }) => {
  return (
    <th className={`py-3 ${classes}`}>
      <button
        type="button"
        onClick={sortData}
        className="flex items-center gap-1"
      >
        <ArrowTableDownSvg />
        <p className="text-semiBlack font-semibold dark:text-semiWhite text-xs leading-6">
          {thName}
        </p>
      </button>
    </th>
  );
};

export default TableHead;
